import React from 'react'
import * as Yup from 'yup'


const formView = (defaultValues, value) => {
	
	
	const widthAngle = window.sections?.[value?.sectionId]?.angleRad || 0
	const widthLabel = `${widthAngle > 0 ? " (" +widthAngle.toFixed(2) + "°)" : ""}`
	console.log(value, value?.sectionId, "defaultValues, value")
	
	return ([
		{
			name: 'sectionId',
			type: 'Hidden',
			labelClassName: 'hidden',
		},
		{
			name: 'image',
			type: 'Hidden',
			labelClassName: 'hidden',
		},
		{
			name: 'name',
			label: 'Section Name',
			placeholder: 'Enter section name',
			type: 'Input',
			defaultValue: defaultValues?.name || null,
			clear: false,
			reset: true,
			validation: Yup.string().required('Name is required'),
		},
		{
			name: 'width',
			label: 'Width (mm)',
			type: 'NumberSlider',
			hint: widthLabel,
			max: 2500,
			defaultValue: defaultValues?.userData?.width || null,
			clear: false,
			reset: false,
			size: 'sm',
			decimal: 1,
		},
		{
			name: 'height',
			label: 'Height (mm)',
			type: 'NumberSlider',
			max: 500,
			defaultValue: defaultValues?.userData?.height || null,
			clear: false,
			reset: false,
			size: 'sm',
			decimal: 0,
		},
		{
			name: 'radialAngle',
			label: 'Radial Angle (degrees)',
			type: 'NumberSlider',
			max: 360,
			min: 0,
			defaultValue: defaultValues?.userData?.radialAngle || 0,
			clear: false,
			reset: false,
			size: 'sm',
			decimal: 0,
		},
		{
			name: 'offsetY',
			label: 'Offset From Bottom (mm)',
			type: 'NumberSlider',
			max: 1000,
			defaultValue: defaultValues?.userData?.offsetY || 0,
			clear: false,
			reset: false,
			size: 'sm',
			decimal: 0,
		},
		
		{
			name: 'offsetX',
			type: 'Hidden',
			defaultValue: 0,
		},
		{
			name: 'sectionAngle',
			label: 'Rotate Section (degrees)',
			type: 'NumberSlider',
			max: 360,
			min: 0,
			defaultValue: defaultValues?.userData?.sectionAngle || 0,
			clear: false,
			reset: false,
			size: 'sm',
			decimal: 0,
		},
		{
			type: 'Divider',
		},
		{
			name: 'deleteSection',
			label: (
				<span className={'flex flex-row gap-sm'}>
        <span className={'font-icon-solid '}></span>
        <span>Delete Section</span>
      </span>
			),
			type: 'Button',
			buttonType: 'link',
			clear: false,
			reset: false,
			size: 'sm',
			className: 'w-[100%] text-red-500 hover:text-red-600 transition-all',
			labelClassName: 'hidden',
			onClick: value?.deleteSection,
		},
		{
			name: 'thumbnail_image_url',
			type: 'Hidden',
			className: 'hidden',
			labelClassName: 'hidden',
		},
	])
}

export default formView
